import { Outlet, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { useSmoothScroll } from '@/components/common/SmoothScrollProvider';

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { scrollToTop } = useSmoothScroll();

  // Scroll to top on route change - use layoutEffect to run before paint
  useLayoutEffect(() => {
    scrollToTop();
  }, [pathname, scrollToTop]);

  return (
    <div className="flex flex-col min-h-screen bg-paper">
      <Header />
      <main className="flex-1 pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
